import type { TLngLat } from 'App/Map/types'
import { PersistentStoreName } from 'stores/_utils/persistentStore/persistenceStoresCleanUpMap'
import { persistentInit } from 'stores/_utils/persistentStore/persistentStore'
import type {
  TBlockId,
  TIrrigationZoneEmitterId,
  TPropertyId,
  TRegionId,
} from 'stores/fieldAssetStore/helperTypes'
import { mapSearchStore } from 'stores/mapSearchStore/mapSearchStore'

export const pointCategories = [
  'fruitGrowthPoint',
  'plantStressPoint',
  'outOfBlockPoint',
  'soilPoint',
  'trapPoint',
  'weatherPoint',
  'pressureTransducerPoint',
  'prePostFilterPoint',
  'windMachinePoint',
  'flowMeterDevice',
] as const

export type TPointCategory = (typeof pointCategories)[number]

export type TSelectedFieldAssetsStoreState = {
  block: TBlockId | null
  irrigationZoneEmitter: TIrrigationZoneEmitterId | null
  lngLat: TLngLat | null
  property: TPropertyId | null
  region: TRegionId | null
} & Record<TPointCategory, TLngLat | null>

export const selectedFieldAssetsStore = persistentInit<TSelectedFieldAssetsStoreState>({
  initialState: {
    block: null,
    fruitGrowthPoint: null,
    plantStressPoint: null,
    irrigationZoneEmitter: null,
    lngLat: null,
    outOfBlockPoint: null,
    property: null,
    soilPoint: null,
    trapPoint: null,
    weatherPoint: null,
    pressureTransducerPoint: null,
    prePostFilterPoint: null,
    windMachinePoint: null,
    region: null,
    flowMeterDevice: null,
  },
  keysToPutInPersistentStorage: {
    block: true,
    fruitGrowthPoint: true,
    plantStressPoint: true,
    irrigationZoneEmitter: true,
    lngLat: true,
    outOfBlockPoint: true,
    property: true,
    soilPoint: true,
    trapPoint: true,
    weatherPoint: true,
    pressureTransducerPoint: true,
    prePostFilterPoint: true,
    windMachinePoint: true,
    region: true,
    flowMeterDevice: true,
  },
  keysToPutInURL: {
    block: true,
    fruitGrowthPoint: true,
    plantStressPoint: true,
    irrigationZoneEmitter: true,
    lngLat: true,
    outOfBlockPoint: true,
    property: true,
    soilPoint: true,
    trapPoint: true,
    weatherPoint: true,
    pressureTransducerPoint: true,
    prePostFilterPoint: true,
    windMachinePoint: true,
    region: true,
    flowMeterDevice: true,
  },
  storeName: PersistentStoreName.SELECTED_FIELD_ASSETS_STORE,
})

selectedFieldAssetsStore.subscribeToChanges(
  (s) => s.property,
  (selectedProperty) => {
    const { highlightedPropertyIds } = mapSearchStore.getState()

    if (!highlightedPropertyIds[Number(selectedProperty)]) {
      mapSearchStore.setState((s) => ({ ...s, highlightedPropertyIds: {} }))
    }
  },
)
